import React from 'react';
import { useSelector } from 'react-redux';

function EmployerReports() {
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  return (
    <div className="py-4">
      <h1>Raporty</h1>
      <div className="alert alert-info">
        Raporty dla: <strong>{userInfo?.company_name}</strong>
      </div>
      <p>Tutaj pojawią się raporty i statystyki dla pracodawcy</p>
    </div>
  );
}

export default EmployerReports;
